import React, {useContext} from "react";
import {ProductContext} from "../../../../pages/ProductStencil";
import {useI18N} from "../../../../my-puratos/hoc/withI18N";
import {RelatedProduct} from "../../../../../interfaces/ecom/schema";


interface BundleItemProps {
    item: RelatedProduct;
    itemIndex: number;
}

export const BundleItem: React.FC<BundleItemProps> = ({item, itemIndex}) => {
    const {activeProductIndex} = useContext(ProductContext);
    const translate = useI18N();

    const isActive = activeProductIndex === itemIndex;
    return (
        <div
            className={`pdp-bundle__item ${isActive ? 'active' : ''}`}
            key={item.MaterialNumber}
        >
            <img src={item.skuImageURL} alt={item.AEMProdName}/>
            {isActive ? (
                <a className="pdp-bundle__item-name" href={item.ProductUrl}>{item.AEMProdName}</a>
            ) : (
                <div className={"pdp-bundle__item-name--not-main"}>
                    <span><strong>1 x </strong><a className="pdp-bundle__item-name" href={item.ProductUrl}>{item.AEMProdName}</a></span>
                    <span className="pdp-bundle__item-price"><strong>{item.TotalPrice}</strong> {translate("each")}</span>
                </div>
            )}
        </div>
    );

}
